import React, { Component } from 'react'
import styled from 'styled-components'
import { graphql, compose } from 'react-apollo'
import MarkNotificationReadMutation from '../../../pipeline/queries/MarkNotificationReadMutation'
import NotesUtil from '../../helpers/NotesUtil'

const Container = styled.div`
  margin-bottom: 15px;
`
const Checkbox = styled.input`
  margin: 0px 5px 0px 0px !important; /* Bootstrap override -_- */
  display: inline-flex;
`
const Description = styled.span`
  color: ${({ checked })=> (checked ? '#808284' : '#3F4042')};
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  a {
    color: #48A3D1;
  }
`

class Checklist extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props
    }
  }

  anchorLinkListener = e => {
    const { target: { tagName } } = e
    if (tagName === 'A') {
      NotesUtil.gotoTab(e)
    }
  }

  markAsRead = async () => {
    const { notificationId, markNotificationRead, onItemClick } = this.props
    const { checked } = this.state
    return markNotificationRead({
      variables: {
        input: {
          notificationId,
          markAsRead: !checked
        }
      },
      update: async (store, { data: { markNotificationRead: { notification: { read } } } }) => {
        this.setState({
          ...this.state,
          checked: read,
        })
        onItemClick(notificationId, read)
      }
    })
  }

  render() {
    const { checked, description } = this.state

    return (
      <Container>
        <Checkbox
          id="checkbox"
          defaultChecked={checked}
          type="checkbox"
          onChange={this.markAsRead}
        />
        <Description
          onClick={this.anchorLinkListener}
          dangerouslySetInnerHTML={{ __html: description }}
          checked={checked}
        />
      </Container>
    )
  }
}

const NotificationWithQuery = compose(
  graphql(MarkNotificationReadMutation, {
    name: 'markNotificationRead'
  })
)(Checklist)

export {Checklist}
export default NotificationWithQuery
